// Import Dependencies
import { createBrowserRouter } from 'react-router';

// Local Imports
import Root from 'app/layouts/Root';
import RootErrorBoundary from 'app/pages/errors/RootErrorBoundary';
import { ghostRoutes } from '../ghost';
import { publicRoutes } from '../public';
import { protectedRoutes } from './protected';

// ----------------------------------------------------------------------

// Simple hydration fallback (not the main app loading screen)
const HydrationFallback = () => (
  <div className="flex h-screen w-screen items-center justify-center bg-white dark:bg-dark-900">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
  </div>
);

const router = createBrowserRouter([
  {
    id: 'root',
    Component: Root,
    hydrateFallbackElement: <HydrationFallback />,
    ErrorBoundary: RootErrorBoundary,
    children: [protectedRoutes, ghostRoutes, publicRoutes],
  },
]);

export default router;
